<template>
  <div class="position-absolute w-100">
    <div
      class="d-flex justify-content-start bg-white overflow-x-auto py-xl-0 py-3  mt-0 rounded navbar-container">
      <div class="d-flex flex-nowrap">
        <div v-for="(navbar, index) in filteredNavbarData" :key="index" class="d-flex mx-2 flex-shrink-0">
          <!-- Main nav item -->
          <button v-if="navbar.dropdown" class="btn s-navbar__nav-link  dropdown-toggle"
            :class="$route.name && $route.name.includes(navbar.slug) ? 'active bg-primary rounded-bottom px-xl-2' : ''"
            @click="toggleDropdown(index)">
            <i :class="navbar.icon"></i>
            <div>
              {{ navbar.title }}
            </div>
          </button>
          <router-link v-else :to="{ name: navbar.name }"
            :class="$route.name && $route.name.includes(navbar.slug) ? 'active bg-primary rounded-bottom px-xl-2' : ''"
            class="s-navbar__nav-link px-xl-0">
            <i :class="navbar.icon"></i>
            <div>
              {{ navbar.title }}
            </div>
          </router-link>
          <!-- Dropdown menu -->
          <ul v-if="navbar.dropdown" class="dropdown-menu border-0 rounded shadow mt-5"
            :class="{ show: navbar.dropdownOpen }">
            <li v-for="(dropdownItem, subIndex) in navbar.dropdown" :key="subIndex">
              <!-- Nested dropdown trigger -->
              <button v-if="dropdownItem.dropdownItems" class="toggle-dropdown-items border-0 dropdown-toggle"
                @click.stop="toggleDropdownItems(index, subIndex)">
                {{ dropdownItem.title }}
                <!-- <i class="bi bi-chevron-down me-2"></i> -->
              </button>
              <!-- Regular dropdown item -->
              <button v-else class="dropdown-item" @click="handleDropdownClick(index, dropdownItem.name)">
                {{ dropdownItem.title }}
              </button>
              <!-- Nested dropdown items -->
              <ul v-if="dropdownItem.dropdownItems" class="dropdown-items border-top ps-3"
                :class="{ show: dropdownItem.dropdownItemsOpen }">
                <li v-for="(subDropdownItem, subItemIndex) in dropdownItem.dropdownItems" :key="subItemIndex">
                  <button @click="handleDropdownClick(index, subDropdownItem.name)" class="dropdown-item">
                    {{ subDropdownItem.title }}
                  </button>
                </li>
              </ul>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.navbar-container {
  max-width: 100%;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
  scrollbar-width: thin;
}

.navbar-container::-webkit-scrollbar {
  height: 4px;
}

.navbar-container::-webkit-scrollbar-thumb {
  background-color: rgba(0, 0, 0, 0.2);
  border-radius: 4px;
}

/* Rest of your existing styles */
.s-navbar__nav-link {
  display: flex;
  align-items: center;
  text-decoration: none;
  color: inherit;
  gap: 0.5rem;
  padding: 0.5rem;
  white-space: nowrap;
}

.s-navbar__nav-link.active {
  color: #0d6efd;
  color: white !important;
}

.dropdown-menu {
  display: none;
  position: absolute;
  min-width: 200px;
  z-index: 1000;
  background-color: white;
}

.dropdown-menu.show {
  display: block;
}

.dropdown-items {
  display: none;
  list-style: none;
  padding-left: 1.5rem;
  margin: 0;
}

.dropdown-items.show {
  display: block;
}

.toggle-dropdown-items {
  background: none;
  cursor: pointer;
  width: 100%;
  text-align: left;
  padding: 0.5rem 1rem;
  display: flex;
  align-items: center;
}

.toggle-dropdown-items:hover {
  background-color: rgba(0, 0, 0, 0.05);
}

.dropdown-item {
  width: 100%;
  text-align: left;
  padding: 0.5rem 1rem;
  border: none;
  background: none;
  cursor: pointer;
  white-space: nowrap;
}

.dropdown-item:hover {
  background-color: rgba(0, 0, 0, 0.05);
}

.bi {
  font-size: 14px !important;
  margin: 0;
}

.bi-logo {
  font-size: 23px !important;
  margin: 0;
}

@media (max-width: 767px) {
  .bi {
    font-size: 32px !important;
    margin: 0;
  }
}
</style>

<!-- <template>
  <div class="position-absolute w-auto">

    <div class="d-flex justify-content-center bg-white overflow-x-auto py-xl-1 py-3 shadow  mt-0 rounded">
      <div v-for="(navbar, index) in filteredNavbarData" :key="index" class="d-flex w-auto mx-2">
        
        <button v-if="navbar.dropdown" class="btn s-navbar__nav-link py-xl-1 px-xl-1 dropdown-toggle"
          :class="$route.name && $route.name.includes(navbar.slug) ? 'active' : ''" @click="toggleDropdown(index)">
          <i :class="navbar.icon"></i>
          <div>
            {{ navbar.title }}
          </div>
        </button>

        <router-link v-else :to="{ name: navbar.name }"
          :class="$route.name && $route.name.includes(navbar.slug) ? 'active' : ''"
          class="s-navbar__nav-link py-xl-1 px-xl-0">
          <i :class="navbar.icon"></i>
          <div>
            {{ navbar.title }}
          </div>
        </router-link>

        <ul v-if="navbar.dropdown" class="dropdown-menu border-0 rounded shadow mt-5"
          :class="{ show: navbar.dropdownOpen }">
          <li v-for="(dropdownItem, subIndex) in navbar.dropdown" :key="subIndex">
            
            <button v-if="dropdownItem.dropdownItems" class="toggle-dropdown-items border-0 dropdown-toggle"
              @click.stop="toggleDropdownItems(index, subIndex)">
              {{ dropdownItem.title }}
            </button>
            
            <button v-else class="dropdown-item" @click="handleDropdownClick(index, dropdownItem.name)">
              {{ dropdownItem.title }}
            </button>

            <ul v-if="dropdownItem.dropdownItems" class="dropdown-items  border-top  ps-3"
              :class="{ show: dropdownItem.dropdownItemsOpen }">
              <li v-for="(subDropdownItem, subItemIndex) in dropdownItem.dropdownItems" :key="subItemIndex">
                <button @click="handleDropdownClick(index, subDropdownItem.name)" class="dropdown-item">
                  {{ subDropdownItem.title }}
                </button>
              </li>
            </ul>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template> -->

<script>
import { mapGetters } from "vuex";
import navbar from "../../data/navbar/index.json";

export default {
  data() {
    return {
      navbarData: this.initializeNavbarData(navbar),
    };
  },
  methods: {
    initializeNavbarData(navbarData) {
      return navbarData.map(item => {
        const newItem = { ...item, dropdownOpen: false };
        if (newItem.dropdown) {
          newItem.dropdown = newItem.dropdown.map(dropdownItem => ({
            ...dropdownItem,
            dropdownItemsOpen: false
          }));
        }
        return newItem;
      });
    },
    toggleDropdown(index) {
      // Close other dropdowns
      this.navbarData.forEach((item, i) => {
        if (i !== index) {
          this.$set(this.navbarData[i], 'dropdownOpen', false);
          if (item.dropdown) {
            item.dropdown.forEach((dropdownItem, j) => {
              if (dropdownItem.dropdownItemsOpen) {
                this.$set(this.navbarData[i].dropdown[j], 'dropdownItemsOpen', false);
              }
            });
          }
        }
      });

      // Toggle current dropdown
      this.$set(this.navbarData[index], 'dropdownOpen', !this.navbarData[index].dropdownOpen);
    },
    toggleDropdownItems(navbarIndex, dropdownIndex) {
      const navbar = this.navbarData[navbarIndex];
      const dropdownItem = navbar.dropdown[dropdownIndex];
      this.$set(navbar.dropdown, dropdownIndex, {
        ...dropdownItem,
        dropdownItemsOpen: !dropdownItem.dropdownItemsOpen
      });
    },
    async handleDropdownClick(index, name) {
      if (name) {
        this.closeDropdown(index);
        this.$router.push({ name });
      }
    },
    closeDropdown(index) {
      this.$set(this.navbarData[index], 'dropdownOpen', false);
      const navbar = this.navbarData[index];
      if (navbar.dropdown) {
        navbar.dropdown.forEach((item, i) => {
          if (item.dropdownItemsOpen) {
            this.$set(navbar.dropdown[i], 'dropdownItemsOpen', false);
          }
        });
      }
    },
    getUserRole() {
      if (!this.authData || !this.authData.role || !this.authData.role.fullName) {
        return '';
      }
      return this.authData.role.fullName;
    }
  },
  computed: {
    ...mapGetters("auth", {
      authData: "getAuthData",
    }),
    filteredNavbarData() {
      const userRole = this.getUserRole();

      if (!userRole) {
        return [];
      }

      // If role is IT, return all navbar items without filtering
      if (userRole === "IT") {
        return this.navbarData;
      }

      const roleMap = {
        "Admin": item => item.is_admin === true,
        "Caissier": item => item.is_cashier === true,
        "Magasinier": item => item.is_storekeeper === true,
        "Commercial": item => item.is_commercial === true,
        "Comptable": item => item.is_accountant === true,
        "Aide Comptable": item => item.is_accountant === true,
      };

      if (!roleMap[userRole]) {
        return [];
      }

      return this.navbarData
        .map(item => {
          if (!roleMap[userRole](item)) {
            return null;
          }

          // Filtrer les dropdowns si existants
          const filteredDropdown = item.dropdown ? item.dropdown.filter(roleMap[userRole]) : [];

          // Retourner l'objet en fonction de la présence de dropdown
          return filteredDropdown.length > 0 ? { ...item, dropdown: filteredDropdown } : { ...item, dropdown: undefined };
        })
        .filter(item => item !== null)
        .map(item => {
          // Supprimer la clé dropdown si elle est vide
          if (!item.dropdown) {
            const { dropdown, ...rest } = item;
            return rest;
          }
          return item;
        });
    }

    // filteredNavbarData() {
    //   const userRole = this.getUserRole();

    //   if (!userRole) {
    //     return [];
    //   }

    //   const roleMap = {
    //     "Admin": item => item.is_admin === true,
    //     "Caissier": item => item.is_cashier === true,
    //     "Magasinier": item => item.is_storekeeper === true,
    //     "Commercial": item => item.is_commercial === true,
    //     "Comptable": item => item.is_accountant === true,
    //     "Aide Comptable": item => item.is_accountant === true,
    //   };

    //   if (!roleMap[userRole]) {
    //     return [];
    //   }

    //   return this.navbarData
    //     .map(item => {
    //       if (!roleMap[userRole](item)) {
    //         return null;
    //       }

    //       // Filtrer les dropdowns si existants
    //       const filteredDropdown = item.dropdown ? item.dropdown.filter(roleMap[userRole]) : [];

    //       // Retourner l'objet en fonction de la présence de dropdown
    //       return filteredDropdown.length > 0 ? { ...item, dropdown: filteredDropdown } : { ...item, dropdown: undefined };
    //     })
    //     .filter(item => item !== null)
    //     .map(item => {
    //       // Supprimer la clé dropdown si elle est vide
    //       if (!item.dropdown) {
    //         const { dropdown, ...rest } = item;
    //         return rest;
    //       }
    //       return item;
    //     });
    // }


  }
};
</script>

<!-- <style scoped>

.s-navbar__nav-link {
  display: flex;
  align-items: center;
  text-decoration: none;
  color: inherit;
  gap: 0.5rem;
  padding: 0.5rem;
}

.s-navbar__nav-link.active {
  color: #0d6efd;
}

.dropdown-menu {
  display: none;
  position: absolute;
  min-width: 200px;
  z-index: 1000;
  background-color: white;
}

.dropdown-menu.show {
  display: block;
}

.dropdown-items {
  display: none;
  list-style: none;
  padding-left: 1.5rem;
  margin: 0;
  /* position: absolute; */
  /* background-color: white; */
  /* margin-left: 200px;
  margin-top: -40px; */
}

.dropdown-items.show {
  display: block;
}

.toggle-dropdown-items {
  background: none;
  /* border: none; */
  cursor: pointer;
  width: 100%;
  text-align: left;
  padding: 0.5rem 1rem;
  display: flex;
  align-items: center;
}

.toggle-dropdown-items:hover {
  background-color: rgba(0, 0, 0, 0.05);
}

.dropdown-item {
  width: 100%;
  text-align: left;
  padding: 0.5rem 1rem;
  border: none;
  background: none;
  cursor: pointer;
}

.dropdown-item:hover {
  background-color: rgba(0, 0, 0, 0.05);
}

.bi {
  font-size: 14px !important;
  margin: 0;
}

.bi-logo {
  font-size: 23px !important;
  margin: 0;
}

@media (max-width: 767px) {
  .bi {
    font-size: 32px !important;
    margin: 0;
  }
}
</style> -->